__turbopack_context__.v({
  "className": "fondamento_8dc62d24-module__CY4zeW__className",
  "variable": "fondamento_8dc62d24-module__CY4zeW__variable",
});
